(function () {
  const EDGE_TOLERANCE = 2;

  function updateSlides(swiperEl) {
    const viewport = swiperEl.getBoundingClientRect();
    if (!viewport.width) return;

    const active = document.activeElement;

    swiperEl.querySelectorAll(':scope > .swiper-wrapper > .swiper-slide').forEach((slide) => {
      const box = slide.getBoundingClientRect();
      const inView =
        box.right > viewport.left + EDGE_TOLERANCE && box.left < viewport.right - EDGE_TOLERANCE;

      const holdsFocus = active && active !== document.body && slide.contains(active);

      slide.toggleAttribute('inert', !inView && !holdsFocus);
    });
  }

  function resetScroll(swiperEl) {
    if (swiperEl.scrollLeft !== 0) swiperEl.scrollLeft = 0;
    if (swiperEl.scrollTop !== 0) swiperEl.scrollTop = 0;
  }

  function lockNavigationButtons(swiperEl) {
    const container = swiperEl.closest('.swiper-container') || swiperEl.parentElement;
    if (!container) return;

    container.querySelectorAll('.swiper-button-next, .swiper-button-prev').forEach((button) => {
      const locked = button.classList.contains('swiper-button-lock');
      button.setAttribute('tabindex', locked ? '-1' : '0');
      button.setAttribute('aria-hidden', locked ? 'true' : 'false');
    });
  }

  function disableLoop(swiperEl) {
    const swiper = swiperEl.swiper;
    if (!swiper || !swiper.params.loop) return;

    swiper.params.loop = false;
    swiper.loopDestroy();
    swiper.update();
  }

  function refresh(swiperEl) {
    disableLoop(swiperEl);
    updateSlides(swiperEl);
    lockNavigationButtons(swiperEl);
  }

  const sizing = new ResizeObserver((entries) => entries.forEach((entry) => refresh(entry.target)));

  function bind(swiperEl) {
    const swiper = swiperEl.swiper;
    if (!swiper || swiperEl.dataset.a11yBound) return;
    swiperEl.dataset.a11yBound = 'true';
    sizing.observe(swiperEl);

    ['slideChange', 'slideChangeTransitionEnd', 'transitionEnd', 'resize', 'update', 'observerUpdate', 'loopFix'].forEach(
      (event) => swiper.on(event, () => refresh(swiperEl))
    );

    swiperEl.addEventListener('scroll', () => resetScroll(swiperEl), { passive: true });

    swiperEl.addEventListener('focusin', () => {
      resetScroll(swiperEl);
      updateSlides(swiperEl);
    });

    refresh(swiperEl);
  }

  function bindAll() {
    document.querySelectorAll('.swiper').forEach(bind);
  }

  function start() {
    bindAll();

    new MutationObserver(bindAll).observe(document.body, {
      childList: true,
      subtree: true,
      attributeFilter: ['class'],
    });

    window.addEventListener('resize', () => document.querySelectorAll('.swiper').forEach(refresh));
    document.addEventListener('shopify:section:load', bindAll);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();